import * as _ from "lodash";

import { ExtensionBase } from "./extensionBase";
import { viewerOptions, viewerState } from "../viewer";
import { UiUtils } from "../common/uiUtils";

const STEP_SIZE = 0.00035;
const SCALE_LIMIT = 0.5;

/**
 * An extension that creates a button for exploding the model to a certain scale.
 */
export class ExplodeExtension extends ExtensionBase {

    static extensionName = "ExplodeExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private explodeButton: Autodesk.Viewing.UI.Button;

    private explodeScale = 0.2;
    private startExplosion = null;
    private explosionReq;
    private isExploding = false;
    private outwardExplosion = true;
   
    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(ExplodeExtension.extensionName, ExplodeExtension);
    }

    load(): boolean {
        console.log(`${ExplodeExtension.extensionName} is loaded!`);
        return super.load();
    };

    unload(): boolean {
        this.viewer.getToolbar(false).removeControl(this.subToolbar);
        return super.unload();
    };

    onToolbarCreated(): void {
        this.explodeButton = UiUtils.createButton({
            id: "SmartDrawings.ExplodeButton",
            tooltip: "Explode Model",
            iconClass: "ion-md-expand",
            onClick: () => {
                if (this.isExploding) {
                    this.contract();
                } else {
                    this.explode();
                }
            }
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.NavExtensions");
        this.subToolbar.addControl(this.explodeButton);
    }

    private explode() {
        window.cancelAnimationFrame(this.explosionReq);
        this.outwardExplosion = true;
        this.explodeScale = _.get(viewerState, "currentRole.uiSettings.explodeLowerLimit") || viewerOptions.uiConstants.explodeStart;
        this.explodeMotion();
        this.isExploding = true;
        this.explodeButton.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
    }

    private contract() {
        window.cancelAnimationFrame(this.explosionReq);
        this.outwardExplosion = false;
        this.explodeMotion();
        this.isExploding = false;
        this.explodeButton.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
    }

    private explodeMotion = (timestamp?) => {
        const scaleLimit = _.get(viewerState, "currentRole.uiSettings.explodeUpperLimit") || SCALE_LIMIT;
        
        if (!this.startExplosion) {
            this.startExplosion = timestamp;
        }
        const progress = timestamp - this.startExplosion;
        this.startExplosion = timestamp;
        // Unscientifically measured to use this formula as animation frame speed is not guaranteed.
        var explodeStep = STEP_SIZE / (viewerOptions.uiConstants.explodeDuration / 1000) * (progress || 0);
      
        if (this.outwardExplosion) {
            this.explodeScale += explodeStep;
        } else {
            this.explodeScale -= explodeStep;
        }
        if (this.explodeScale > scaleLimit) {
            window.cancelAnimationFrame(this.explosionReq);
            this.explodeScale = scaleLimit; 
        } else if (this.explodeScale < 0) {
            window.cancelAnimationFrame(this.explosionReq);
            this.explodeScale = 0; 
        } else {
            (this.viewer as any).explode(this.explodeScale);
            this.explosionReq = window.requestAnimationFrame(this.explodeMotion);
        }
    };

}